import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import { collection, addDoc, Timestamp } from "firebase/firestore";
import { db } from "../FirebaseComp/firebase";
import "./body.css";
import { motion, AnimatePresence } from "framer-motion";
import {   FaBuilding } from 'react-icons/fa';

import { useNavigate } from 'react-router-dom';
import { 
  FaTrophy, 
  FaWrench, 
  FaBook, 
  FaHandshake,
  FaStar,
  FaUsers,
  FaAward,
  FaChartLine
} from 'react-icons/fa';



function Body() {

const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

 const [members, setMembers] = useState([

          {
         id: 20,
      name: "Eye Care Clinic & Optical",
      location: "Colombo 08",
      phone: "+94112682277", 
      googleMap: "https://share.google/nuYSdVZ3bIMFjUPj8",
      images: [
        "/shops/eye care/1.jpeg",
        "/shops/eye care/2.jpeg",
        "/shops/eye care/3.jpeg",
        "/shops/eye care/4.jpeg",
        "/shops/eye care/5.jpeg",
    
      ],
      currentIndex: 0,
    },



  {
    id: 1,
    // membershipNo: "",
    name: "Wijesundara Optometrist",
    // category: "Optometrist",
    // validFrom: "2024",
    // validTo: "2025",
    // shopName: "",
    location: "Kuruwita",
    googleMap: "https://share.google/m0bP9Pk9mqVgqU0Qh",
    images: [
      "/shops/BLGR-WIJESUNDARA/1.jpg",
      "/shops/BLGR-WIJESUNDARA/2.jpg",
    ],
    currentIndex: 0,
  },

  {
    id: 2,
    membershipNo: "",
    name: "Family vision center ",
    // category: "Optometrist",
    // validFrom: "2024",
    // validTo: "2025",
    // shopName: "Optica Eye Care",
    location: "Kottawa",
    googleMap: "https://maps.app.goo.gl/Q6MGxAutDgqubwYS6",
    images: [
      "/shops/Dharshilekha/1.jpeg",
      "/shops/Dharshilekha/2.jpeg",
      
    ],
    currentIndex: 0,
  },
  {
    id: 3,
    membershipNo: "",
    name: "Gamage Opticals Pvt Ltd",
    // category: "Optometrist",
    // validFrom: "2024",
    // validTo: "2025",
    // shopName: "Optica Eye Care",
    location: "Nawalapitiya",
    googleMap: "https://maps.app.goo.gl/fCuiKwWM3wD5k1uL6?g_st=iw",
    images: [
      "/shops/DilrukshiGamage/1.jpeg",
      "/shops/DilrukshiGamage/2.jpeg",
   
    ],
    currentIndex: 0,
  },
  {
    id: 4,
    membershipNo: "",
    name: "Deneth Opticians",
    // category: "Optometrist",
    // validFrom: "2024",
    // validTo: "2025",
    // shopName: "Optica Eye Care",
    location: "Avissawella",
    googleMap: "https://share.google/3ReLp6R5dohCoj0jQ",
    images: [
      "/shops/DilshaniSamudika/1.jpg",
      "/shops/DilshaniSamudika/2.jpg",
      "/shops/DilshaniSamudika/3.jpg",
      "/shops/DilshaniSamudika/4.jpg",
    ],
    currentIndex: 0,
  },

  {
    id: 5,
    membershipNo: "",
    name: "Anura Opticians",
    // category: "Optometrist",
    // validFrom: "2024",
    // validTo: "2025",
    // shopName: "Optica Eye Care",
    location: "Panadura",
    googleMap: "https://maps.app.goo.gl/N6HP7Tnaxh2PkEUo9",
    images: [
      "/shops/AnuraPerera/2.jpg",
      "/shops/AnuraPerera/1.jpg",
    
      
    ],
    currentIndex: 0,
  },
  {
    id: 6,
    membershipNo: "",
    name: "Ganeesha Optical",
    // category: "Optometrist",
    // validFrom: "2024",
    // validTo: "2025",
    // shopName: "Optica Eye Care",
    location: "Tangalle",
    googleMap: "https://share.google/D2U992QvK5ktzqNF8",
    images: [
      "/shops/GGMadushani/1.jpg",
      "/shops/GGMadushani/2.jpg",
      "/shops/GGMadushani/3.jpg",
      "/shops/GGMadushani/4.jpg",
      "/shops/GGMadushani/5.jpg",
    ],
    currentIndex: 0,
  },
  {
    id: 7,
    membershipNo: "",
    name: "Marasinghe optician",
    // category: "Optometrist",
    // validFrom: "2024",
    // validTo: "2025",
    // shopName: "Optica Eye Care",
    location: "Marawila",
    googleMap: "https://share.google/BgYiOu1f2yLT1ttmd",
    images: [
      "/shops/Namali/1.jpeg",
      "/shops/Namali/2.jpeg",
      "/shops/Namali/3.jpeg",
      "/shops/Namali/4.jpeg",
      "/shops/Namali/5.jpeg",
      "/shops/Namali/6.jpeg",
      "/shops/Namali/7.jpeg",
    ],
    currentIndex: 0,
  },
  {
    id: 8,
    membershipNo: "",
    name: "Nethini Eye Care Pvt Ltd",
    // category: "Optometrist",
    // validFrom: "2024",
    // validTo: "2025",
    // shopName: "Optica Eye Care",
    location: "Wattala",
    googleMap: "https://share.google/TX4a3bX1oq0BXvkfv",
    images: [
      "/shops/PrabhaAPerera/1.jpg",
      "/shops/PrabhaAPerera/2.jpg",
      "/shops/PrabhaAPerera/3.jpg",
    ],
    currentIndex: 0,
  },

]);





  const [formData, setFormData] = useState({
    institutionName: "",
    brNo: "",
    establishedDate: "",
    address: "",
    telephone: "",
    email: "",
    website: "",
    divisionalSecretary: "",
    district: "",
    province: "",
    contactPerson: "",
    contactAddress: "",
    contactPhone: "",
    position: "",
    qualification: "",
    institutionType: {
      retailOptical: false,
      wholesale: false,
      investor: false,
      other: false,
      otherSpecify: ""
    },
    infrastructure: {},
    amenities: {}
  });

 




  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({
      institutionName: "",
      brNo: "",
      establishedDate: "",
      address: "",
      telephone: "",
      email: "",
      website: "",
      divisionalSecretary: "",
      district: "",
      province: "",
      contactPerson: "",
      contactAddress: "",
      contactPhone: "",
      position: "",
      qualification: "",
      institutionType: {
        retailOptical: false,
        wholesale: false,
        investor: false,
        other: false,
        otherSpecify: ""
      },
      infrastructure: {},
      amenities: {}
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (type === "checkbox") {
      if (name.includes("institutionType.")) {
        const field = name.split(".")[1];
        setFormData({
          ...formData,
          institutionType: {
            ...formData.institutionType,
            [field]: checked
          }
        });
      } else {
        setFormData({
          ...formData,
          [name]: checked
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleInfrastructureChange = (item, field, value) => {
    setFormData({
      ...formData,
      infrastructure: {
        ...formData.infrastructure,
        [item]: {
          ...formData.infrastructure[item],
          [field]: value
        }
      }
    });
  };

  const handleAmenitiesChange = (amenity, field, value) => {
    setFormData({
      ...formData,
      amenities: {
        ...formData.amenities,
        [amenity]: {
          ...formData.amenities[amenity],
          [field]: value
        }
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await addDoc(collection(db, "optica-memberships"), {
        ...formData,
        createdAt: Timestamp.now()
      });

      await emailjs.send(
        "service_f5biz1g",
        "template_z0p1yu7",
        {
          institutionName: formData.institutionName,
          brNo: formData.brNo,
          establishedDate: formData.establishedDate,
          address: formData.address,
          telephone: formData.telephone,
          email: formData.email,
          website: formData.website,
          divisionalSecretary: formData.divisionalSecretary,
          district: formData.district,
          province: formData.province,
          contactPerson: formData.contactPerson,
          contactAddress: formData.contactAddress,
          contactPhone: formData.contactPhone,
          position: formData.position,
          qualification: formData.qualification,
          institutionType: Object.entries(formData.institutionType)
            .filter(([key, value]) => key !== "otherSpecify" && value)
            .map(([key]) => key)
            .concat(formData.institutionType.otherSpecify ? [formData.institutionType.otherSpecify] : [])
            .join(", ")
        },
        "0tqu3JXAHOi2utnXT"
      );

      alert("Registration submitted successfully!");
      closeModal();
    } catch (error) {
      console.error("Submission Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };







    const images = [
      "/banner-optica1.png",
    "/optica banner2.png",
    "/optica banner3.png",
  
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 4000); // change every 4 seconds

    return () => clearInterval(interval);
  }, []);








const handleNextImage = (index) => {
  setMembers(prevMembers =>
    prevMembers.map((m, i) =>
      i === index
        ? { ...m, currentIndex: (m.currentIndex + 1) % m.images.length }
        : m
    )
  );
};

const handlePrevImage = (index) => {
  setMembers(prevMembers =>
    prevMembers.map((m, i) =>
      i === index
        ? {
            ...m,
            currentIndex:
              (m.currentIndex - 1 + m.images.length) % m.images.length,
          }
        : m
    )
  );
}







  return (
    <div className="landing">





      {/* Hero Section with ID */}
      {/* Hero Section with ID */}
  <section id="home" className="optica-hero-section">

      <img
        src={images[currentImage]}
        alt="optica international"
        className="optica-hero-banner"
      />

      <div className="optica-hero-content">

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="optica-hero-title"
        >
    
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="optica-hero-subtitle"
        >
  
        </motion.p>

      </div>

    </section>



      {/* About Us Section */}
  <section id="about" className="section about">
      <div className="container">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          OPTICA INTERNATIONAL
        </motion.h2>

        <div className="about-content">
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3>Leading the Future of Eye Care Technology</h3>
            <p className="about-description">
              Optica International has established itself as a premier provider of 
              clinical diagnostic equipment across Sri Lanka. With over a decade of 
              experience, we bridge the gap between global manufacturers and local 
              healthcare providers, ensuring that eye care professionals have access 
              to world-class technology.
            </p>
            
            <div className="stats-container">
              <div className="stat-item">
                <span className="stat-number">15+</span>
                <span className="stat-label">Years of Excellence</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">50+</span>
                <span className="stat-label">Happy Members</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">100+</span>
                <span className="stat-label">Equipment Supplied</span>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="benefits-list"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h4>Why Eye Care Professionals Choose Us</h4>
            
            <div className="benefit-item">
              <div className="benefit-icon">
                <FaTrophy />
              </div>
              <div className="benefit-content">
                <h5>Exclusive Access to Premium Brands</h5>
                <p>Members gain priority access to top international eye care equipment brands at special pricing.</p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">
                <FaWrench />
              </div>
              <div className="benefit-content">
                <h5>Comprehensive Technical Support</h5>
                <p>24/7 technical assistance, installation services, and maintenance support for all equipment.</p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">
                <FaBook />
              </div>
              <div className="benefit-content">
                <h5>Continuous Professional Development</h5>
                <p>Free training workshops, webinars, and certification programs for member professionals.</p>
              </div>
            </div>

            <div className="benefit-item">
              <div className="benefit-icon">
                <FaHandshake />
              </div>
              <div className="benefit-content">
                <h5>Networking Opportunities</h5>
                <p>Connect with leading eye care professionals, hospitals, and industry experts through exclusive events.</p>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div 
          className="why-join-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >

        </motion.div>


      </div>
    </section>










      {/* Benefits Section */}
      <section id="benefits" className="section benefits">
        <div className="container">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Benefits of Optica International Membership
          </motion.h2>
<div className="benefits-grid">
  {[
    { 
      image: '/Cost.jpeg', 
      title: 'Reduce Your Cost of Purchase', 
      desc: 'Save more with exclusive member pricing and bulk purchase discounts on all diagnostic equipment and supplies.' 
    },
    { 
      image: '/improve.png', 
      title: 'Improve Your Practice Place', 
      desc: 'Get expert guidance on optimizing your optical practice layout, workflow, and professional environment.' 
    },
    { 
      image: '/boost.png', 
      title: 'Promote Your Business', 
      desc: 'Increase your visibility through our professional network, referrals, and marketing support programs.' 
    }
  ].map((benefit, index) => (
    <motion.div
      key={index}
      className="benefit-card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.2 }}
      whileHover={{ y: -10 }}
    >
      <div className="benefit-image">
        <img src={benefit.image} alt={benefit.title} />
      </div>
      <h3>{benefit.title}</h3>
      <p>{benefit.desc}</p>
    </motion.div>
  ))}
</div>
        </div>
      </section>

      {/* Experience Section */}
      <section className="section experience">
        <div className="container">
          <div className="experience-content">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              Years of Excellence in Eye Care
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              has been dedicated to advancing eye care services through innovation,
              professional networking, and trusted partnerships.
            </motion.p>

            <div className="experience-stats">
              {[
                { number: '15+', label: 'Years Experience' },
                { number: '50+', label: 'Members' },
                { number: '30+', label: 'Industry Partners' }
              ].map((stat, index) => (
                <motion.div
                  key={index}
                  className="stat-card"
                  initial={{ opacity: 0, scale: 0.8 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.2 }}
                >
                  <h3>{stat.number}</h3>
                  <p>{stat.label}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="section why-choose">
        <div className="container">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            Why Choose Us
          </motion.h2>

          <div className="why-grid">
      {[
  { 
    icon: <FaHandshake />,
    title: 'Trusted Suppliers', 
    desc: 'We work only with verified and globally trusted eye care equipment suppliers.' 
  },
  { 
    icon: <FaStar />, 
    title: 'Professional Standards', 
    desc: 'Our network follows strict professional and ethical standards in eye care.' 
  },
  { 
    icon: <FaBuilding />, 
    title: 'Industry Partnerships', 
    desc: 'Strong partnerships with hospitals, clinics, and optical organizations.' 
  }
].map((item, index) => (

              <motion.div
                key={index}
                className="why-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                whileHover={{ scale: 1.05 }}
              >
                <span>{item.icon}</span>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </motion.div>
            ))}

          </div>
        </div>
      </section>






    {/* Membership Directory */}
<section id="directory" className="section directory">
  <div className="container">
    <motion.h2
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      Members of Optica International
    </motion.h2>

    <p className="section-subtitle">
      Verified members of Optica International Pvt Ltd
    </p>

    <div className="directory-grid">
      {members.slice(0, 8).map((member, index) => (
        <motion.div
          className="member-card"
          key={member.id}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
          whileHover={{ y: -10 }}
        >
     
          <div className="slider-container">
            <img
              src={member.images[member.currentIndex]}
              alt={member.name}
              className="slider-image"
            />

            <button
              className="slider-arrow left"
              onClick={() => handlePrevImage(index)}
            >
              ❮
            </button>

            <button
              className="slider-arrow right"
              onClick={() => handleNextImage(index)}
            >
              ❯
            </button>
          </div>

          <div className="member-info">
    
            <h4>{member.name}</h4>

            <span className="member-category">{member.category}</span>



            <p className="optical-name">{member.shopName}</p>
            <p className="optical-location">{member.location}</p>

            <a
              href={member.googleMap}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-location"
            >
              Get Location
            </a>
          </div>
        </motion.div>
      ))}
    </div>

    <div className="more-btn-wrap">
      <a href="/membership-directory" className="btn-more">View More</a>
    </div>
  </div>
</section>





{/* Membership Section */}
<section id="membership" className="section membership">
  <div className="container">
    <motion.h2
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      Membership Registration
    </motion.h2>
    
    <motion.div 
      className="membership-content"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      <div className="membership-text">
        <h3>Join Our Professional Network</h3>
        <p>Become a part of Optica International and gain access to exclusive benefits, technical support, training updates, and special pricing for eye care equipment and services.</p>
      </div>
      
      <div className="membership-features">
        <div className="feature-item">
          <span className="feature-icon">✓</span>
          <span>Exclusive Products</span>
        </div>
        <div className="feature-item">
          <span className="feature-icon">✓</span>
          <span>Technical Support</span>
        </div>
        <div className="feature-item">
          <span className="feature-icon">✓</span>
          <span>Training Updates</span>
        </div>
        <div className="feature-item">
          <span className="feature-icon">✓</span>
          <span>Special Pricing</span>
        </div>
      </div>
      
      <motion.button 
        className="membership-btn"
        onClick={() => navigate('/registration')}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Register Now
        <span className="btn-arrow">→</span>
      </motion.button>
    </motion.div>
  </div>
</section>








      {/* Testimonials */}
      <section className="section testimonials">
        <div className="container">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            What Our Members Say
          </motion.h2>

          <div className="testimonial-grid">
            {[
              { text: "“Joining Optica International helped us reduce costs and grow our optical practice.”", name: "Sadun Bamunusinghe", role: "Eye Clinic Owner" },
              { text: "“Professional support and trusted suppliers make a real difference in our clinic.”", name: "Optom. Lahiru Malinda Rodrigo", role: "Eye Clinic Owner" },
              { text: "“A strong network that truly understands the eye care industry.”", name: "Eranda Nadeeshan", role: "Optical Distributor" }
            ].map((testimonial, index) => (
              <motion.div
                key={index}
                className="testimonial-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                whileHover={{ y: -10 }}
              >
                <p>{testimonial.text}</p>
                <h4>{testimonial.name}</h4>
                <span>{testimonial.role}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* News & Updates */}
      {/* <section className="section news">
        <div className="container">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            News & Updates
          </motion.h2>

          <div className="news-grid">
            {[
              { date: "Mar 2026", title: "New Membership Benefits Launched", desc: "Exclusive discounts and promotional opportunities introduced for members." },
              { date: "Feb 2026", title: "Upcoming Eye Care Workshop", desc: "Professional training program for optometrists and clinic staff." },
              { date: "Jan 2026", title: "Strategic Industry Partnership", desc: "Collaboration with leading medical equipment suppliers announced." }
            ].map((news, index) => (
              <motion.div
                key={index}
                className="news-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                whileHover={{ scale: 1.05 }}
              >
                <span className="news-date">{news.date}</span>
                <h3>{news.title}</h3>
                <p>{news.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section> */}




      

    </div>
  );
}

export default Body;